'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var utils = require('@chakra-ui/utils');
var React = require('react');
var reactAria = require('react-aria');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * useFieldPropsWithEvents
 *
 * Merges events from `fieldProps` with events given from the user. By default, `fieldProps` omits all user-provided
 * events.
 *
 * The logic within handles the changing focus & blur states when moving between segments.
 *
 * @param fieldProps - Props from `useAriaDateField` or `useAriaTimeField`.
 * @param state - State from `useDateFieldState` or `useTimeFieldState`. Both hooks return `DateFieldState`.
 * @param props - Props from the user.
 */
var useFieldPropsWithEvents = function useFieldPropsWithEvents(fieldProps, state) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp;

  // `onFocusWithin` makes it so that `onFocus` and `onBlur` are only executed when the user enters or leaves the
  // entire field, and not when changing between segments, which is the case natively.
  var _useFocusWithin = reactAria.useFocusWithin({
      // We do not pass the native events here as they can't give `target.value` (which is expected for a form
      // element) as the underlying element is not a native form input. This would lead to confusing errors. Instead,
      // we make it clear that this is custom.
      //
      // @TODO: Check again if this is a good idea when implementing the react-hook-form compatible events.
      onBlurWithin: function onBlurWithin() {
        return onBlur === null || onBlur === void 0 ? void 0 : onBlur(state === null || state === void 0 ? void 0 : state.value);
      },
      onFocusWithin: function onFocusWithin() {
        return onFocus === null || onFocus === void 0 ? void 0 : onFocus(state === null || state === void 0 ? void 0 : state.value);
      }
    }),
    focusWithinProps = _useFocusWithin.focusWithinProps;
  return React.useMemo(function () {
    return _objectSpread(_objectSpread({}, fieldProps), {}, {
      onFocus: utils.callAllHandlers(focusWithinProps.onFocus, fieldProps.onFocus),
      onBlur: utils.callAllHandlers(focusWithinProps.onBlur, fieldProps.onBlur),
      onKeyDown: utils.callAllHandlers(onKeyDown, fieldProps.onKeyDown),
      onKeyUp: utils.callAllHandlers(onKeyUp, fieldProps.onKeyUp)
    });
  }, [fieldProps, onFocus, onBlur, onKeyDown, onKeyUp]);
};
exports.useFieldPropsWithEvents = useFieldPropsWithEvents;